<template>
  <div class="pageWrapper">
    <nuxt ref="page" />
  </div>
</template>

<script>
export default {
  name: 'EmptyView',
};
</script>
